import * as React from 'react';
import MenuCompetencePerformanceEvaluation from "../Components/MenuCompetencePerformanceEvaluation";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#f5f6f9',
      color: '#222222',
      fontFamily: 'Arial',
      fontSize: 14,
      fontWeight: 'bold',
      height: "25px"
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);

interface Data {
    id: number;
    nameCompetence: string;
    DescriptionCompetence: string;
  }
  
  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  type Order = 'asc' | 'desc';
  
  function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
  ): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string },
  ) => number {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  } 

  function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  interface HeadCell {
    disablePadding: boolean;
    id:  keyof Data;
    label: string;   
    width: string; 
  }
  
  const headCells: readonly HeadCell[] = [
    {
      id: 'nameCompetence',      
      disablePadding: false,
      label: 'Competencia',
      width: '30%'
    },
    {
      id: 'DescriptionCompetence',    
      disablePadding: false,
      label: 'Descripción',
      width: '50%'
    },
    {
      id: 'id',       
      disablePadding: false,
      label: 'Opciones',
      width: '10%'
    } 
  ];
  
  interface EnhancedTableProps {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
  }
  
  function EnhancedTableHead(props: EnhancedTableProps) {  
    const { order, orderBy, numSelected,
        rowCount,
        onRequestSort } =
      props;
    const createSortHandler =
      (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
      };
  
    return (
      <TableHead>
        <TableRow>
           {headCells.map((headCell) => (
            <StyledTableCell
              className="tableHeader"
              key={headCell.id}                   
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{ width: headCell.width }}
            >
               <TableSortLabel
                active={orderBy === headCell.id}
                 direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                className="labelHeader"
              >
                {headCell.label}             
              </TableSortLabel>
            </StyledTableCell>
          ))} 
        </TableRow>
      </TableHead>
    );
  }

const TableCompetenceEvaluation = ({rows,setArrayIncident,selected,setSelected,page,setPage}:any) => {
    const [order, setOrder] = React.useState<Order>("desc");
    const [orderBy, setOrderBy] = React.useState<keyof Data>("id");  
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
   
    const handleRequestSort = (
      event: React.MouseEvent<unknown>,
      property: keyof Data
    ) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };
    
    const handleChangePage = (event: unknown, newPage: number) => {      
      setPage(newPage);
    };

  
    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const isSelected = (id: number) => selected.indexOf(id) !== -1;
  
    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;    
    
    const visibleRows = React.useMemo(
      () =>
        stableSort(rows, getComparator(order, orderBy)).slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        ),
      [order, orderBy, page, rows, rowsPerPage]
    );
  
    return (
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%"}}>
          <TableContainer>
            <Table
              sx={{ minWidth: 600 }}
              aria-labelledby="tableTitle"             
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {visibleRows.map((row, index) => {
                  const castId=Number(row.id)
                  const isItemSelected = isSelected(castId);
                  const labelId = `enhanced-table-checkbox-${index}`;  
                  return (
                    <TableRow             
                      hover                              
                      tabIndex={-1}
                      key={row.id}      
                      sx={{ cursor: "pointer" }}                
                    >
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"                                            

                      >
                       {/* <div className="containerTwo">
                          <div className="containerInfoName">  </div>
                       </div>                      */}
                       {row.nameCompetence}
                      </TableCell>
                      <TableCell align="left">{row.DescriptionCompetence}</TableCell>
                     <TableCell align="left" >
                       <MenuCompetencePerformanceEvaluation 
                             id={row.id}
                             infoRow={row}
                              />                          
                     </TableCell>
                    </TableRow>
                  );
                })} 
                {emptyRows > 0 && (
                  <TableRow>
                    <TableCell colSpan={11} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage='Número de registros'    
          />
        </Paper>        
      </Box>
    );
}

export default TableCompetenceEvaluation

